<template>

    <div 
        @mouseover="showBlockActionButtons = true" 
        @mouseleave="showBlockActionButtons = false" 
        >

        <div v-if="showBlockChildSettingsGuide" class="settings-box-child-guide" :id="'child-block-settings-'+slideId+'-guide'"></div>

        <!-- slide settings -->
        <transition name="slide-fade">

            <vue-draggable-resizable 
            :resizable="false" 
            :drag-handle="'.settings-box-child-title'"
            :w="setBoxWidth" :h="setBoxHeight" :z="999" 
            class="settings-box-child" 
            v-if="showChildSettings" 
            :x="centerPositionSettingsBoxX"
            :y="centerPositionSettingsBoxY"

            :id="'child-block-settings-'+slideId">
                <!-- settings group: CHILD BLOCKS -->
                <div class="settings-box-child-title">
                    <h6>slide settings</h6>
                </div>

                <div class="settings-box-child-inner">

                    <div>

                        <div>

                            <!-- styles settings -->
                            <div class="setting-section">
                                <div class="setting-section-title">
                                    <h6>styles</h6>
                                </div>
                                <div class="setting-section-content">

                                    <!-- label background type -->
                                    <label>Select background type:</label>
                                    <!-- background type child -->
                                    <div class="setting setting-toggle-group">
                                        <b-form-checkbox switch v-model="slide.backgroundColorChild"  @change="useBackgroundColor(slideIndex)">
                                            Background color
                                        </b-form-checkbox>
                                    
                                        <b-form-checkbox switch v-model="slide.backgroundImageChild" @change="useBackgroundImage(slideIndex)">
                                            Background image
                                        </b-form-checkbox>
                                        
                                    </div>

                                    <!-- background color picker child -->
                                    <div class="setting" v-if="slide.backgroundColorChild">
                                        <Mycolorpickerchildblocksslide elementRef="childBackground" theColorPicker="allpickers" colorPickerName="Select background color:" :indexNr="slideIndex" />
                                    </div><!-- v-if="slide.backgroundColorChild -->

                                    <!-- background image child -->
                                    <div v-if="slide.backgroundImageChild">

                                        <!-- upload bg -->
                                        <div class="setting">
                                            <label>Upload background image:</label>
                                            <b-form-file name="image_field" @change="onFileSelected(slideIndex)" accept="image/*" />
                                        </div>

                                        <!-- background position axis -->
                                        <div class="setting">
                                            <b-form-group>

                                                <label>Image position x axis:</label>
                                                <b-form-select v-model="slide.xAxisPosition" size="sm">
                                                    <option value="left">Left</option>
                                                    <option value="center">Center</option>
                                                    <option value="right">Right</option>
                                                </b-form-select>

                                            </b-form-group>
                                        </div>

                                        <!-- background position y axis -->
                                        <div class="setting">
                                            <b-form-group>

                                                <label>Image position y axis:</label>
                                                <b-form-select v-model="slide.yAxisPosition" size="sm">
                                                    <option value="top">Top</option>
                                                    <option value="center">Center</option>
                                                    <option value="bottom">Bottom</option>
                                                </b-form-select>

                                            </b-form-group>
                                        </div>



                                    </div><!-- v-if="slide.backgroundImageChild" -->


                                    <div v-if="!slide.useIndividualBorder">

                                        <div class="border-group">

                                            <div class="border-group--title">
                                                Border
                                            </div>
                                            <i class="fas unlink-border-radius fa-link" @click="slide.useIndividualBorder = !slide.useIndividualBorder" v-b-tooltip.hover.top title="Set borders individually"></i>

                                            <!--  general border width DESKTOP -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-generalborderwidth-input">Width:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-generalborderwidth-input" type="number" v-model="slide.borderGeneralWidth" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>   

                                            <!--  general border color -->
                                            <div class="setting">
                                                <Mycolorpickerchildblocksslide elementRef="borderGeneralColor" theColorPicker="allpickers" colorPickerName="Color:" :indexNr="slideIndex" />
                                            </div>

                                            <!-- border type general -->
                                            <div class="setting">
                                                <b-form-group label="Style:">

                                                    <b-form-select v-model="slide.borderGeneralStyle" size="sm">

                                                        <option value="solid">Solid</option>

                                                        <option value="dotted">Dotted</option>

                                                        <option value="dashed">Dashed</option>

                                                        <option value="double">Double</option>

                                                    </b-form-select>

                                                </b-form-group>
                                            </div>

                                        </div><!-- border-group -->
                                        
                                    </div><!-- v-if="!slide.useIndividualBorder" -->

                                    <div v-if="slide.useIndividualBorder">

                                        <div class="border-group">

                                            <div class="border-group--title">
                                                Border top desktop
                                            </div>
                                            <i class="fas unlink-border-radius fa-unlink" @click="slide.useIndividualBorder = !slide.useIndividualBorder" v-b-tooltip.hover.top title="Set borders equally"></i>
                                    
                                            <!--  border top width DESKTOP -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-generalborderwidth-input">Border top width desktop:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-generalborderwidth-input" type="number" v-model="slide.borderTopWidth" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>   

                                            <!--  border top color -->
                                            <div class="setting">
                                                <Mycolorpickerchildblocksslide elementRef="borderTopColor" theColorPicker="allpickers" colorPickerName="Border top color:" :indexNr="slideIndex" />
                                            </div>

                                            <!-- border top type -->
                                            <div class="setting">
                                                <b-form-group label="Border top style:">

                                                    <b-form-select v-model="slide.borderTopStyle" size="sm">

                                                        <option value="solid">solid</option>

                                                        <option value="dotted">dotted</option>

                                                        <option value="dashed">dashed</option>

                                                        <option value="double">double</option>

                                                    </b-form-select>

                                                </b-form-group>
                                            </div>

                                        </div><!-- border-group -->

                                        <div class="border-group">

                                            <div class="border-group--title">
                                                Border right desktop
                                            </div>

                                            <!--  border right width DESKTOP -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-borderRightWidthDesk-input">Width:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-borderRightWidthDesk-input" type="number" v-model="slide.borderRightWidth" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>   

                                            <!--  border right color -->
                                            <div class="setting">
                                                <Mycolorpickerchildblocksslide elementRef="borderRightColor" theColorPicker="allpickers" colorPickerName="Color:" :indexNr="slideIndex" />
                                            </div>

                                            <!-- border right type -->
                                            <div class="setting">
                                                <b-form-group label="Style:">

                                                    <b-form-select v-model="slide.borderRightStyle" size="sm">

                                                        <option value="solid">solid</option>

                                                        <option value="dotted">dotted</option>

                                                        <option value="dashed">dashed</option>

                                                        <option value="double">double</option>

                                                    </b-form-select>

                                                </b-form-group>
                                            </div>
                                        
                                        </div><!-- border-group -->

                                        <div class="border-group">

                                            <div class="border-group--title">
                                                Border bottom desktop
                                            </div>
                                            <!--  border bottom width DESKTOP -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-borderBottomWidth-input">Width:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-borderBottomWidth-input" type="number" v-model="slide.borderBottomWidth" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>   

                                            <!--  border bottom color -->
                                            <div class="setting">
                                                <Mycolorpickerchildblocksslide elementRef="borderBottomColor" theColorPicker="allpickers" colorPickerName="Color:" :indexNr="slideIndex" />
                                            </div>

                                            <!-- border bottom type -->
                                            <div class="setting">
                                                <b-form-group label="Style:">

                                                    <b-form-select v-model="slide.borderBottomStyle" size="sm">

                                                        <option value="solid">solid</option>

                                                        <option value="dotted">dotted</option>

                                                        <option value="dashed">dashed</option>

                                                        <option value="double">double</option>

                                                    </b-form-select>

                                                </b-form-group>
                                            </div>

                                        </div><!-- border-group -->

                                        <div class="border-group">

                                            <div class="border-group--title">
                                                Border left desktop
                                            </div>
                                            
                                            <!--  border left width DESKTOP -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-borderLeftWidth-input">Width:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-borderLeftWidth-input" type="number" v-model="slide.borderLeftWidth" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>   

                                            <!--  border left color -->
                                            <div class="setting">
                                                <Mycolorpickerchildblocksslide elementRef="borderLeftColor" theColorPicker="allpickers" colorPickerName="Color:" :indexNr="slideIndex" />
                                            </div>

                                            <!-- border left type -->
                                            <div class="setting">
                                                <b-form-group label="Style:">

                                                    <b-form-select v-model="slide.borderLeftStyle" size="sm">

                                                        <option value="solid">solid</option>

                                                        <option value="dotted">dotted</option>

                                                        <option value="dashed">dashed</option>

                                                        <option value="double">double</option>

                                                    </b-form-select>

                                                </b-form-group>
                                            </div>
                                        </div><!-- border-group -->

                                    </div><!-- v-if="slide.useIndividualBorder" -->

                                    <!-- border radius -->
                                    <div class="border-group">

                                        <div class="border-group--title">
                                            Border radius desktop
                                        </div>
                                        <i class="fas unlink-border-radius fa-link" @click="slide.useIndividualBorderRadius = !slide.useIndividualBorderRadius" v-b-tooltip.hover.top title="Set border radius individually"></i>

                                        <!--  general border radius DESKTOP -->
                                        <div class="setting" v-if="!slide.useIndividualBorderRadius">
                                            <b-form-group>

                                                <label for="child-generalborderradius-input">Radius:</label>
                                                
                                                <b-input-group append="px" size="sm">
                                                    <b-form-input id="child-generalborderradius-input" type="number" v-model="slide.borderRadiusGeneral" min="0" />
                                                </b-input-group>

                                            </b-form-group>
                                        </div>

                                        <!--  general border radius top left DESKTOP -->
                                        <div class="setting" v-if="slide.useIndividualBorderRadius">
                                            <b-form-group>

                                                <label for="child-borderradiuslefttop-input">Top left:</label>
                                                
                                                <b-input-group append="px" size="sm">
                                                    <b-form-input id="child-borderradiuslefttop-input" type="number" v-model="slide.borderTopLeftRadius" min="0" />
                                                </b-input-group>

                                            </b-form-group>
                                        </div>  

                                        <!--  general border radius top right DESKTOP -->
                                        <div class="setting" v-if="slide.useIndividualBorderRadius">
                                            <b-form-group>

                                                <label for="child-borderradiusrighttop-input">Top right:</label>
                                                
                                                <b-input-group append="px" size="sm">
                                                    <b-form-input id="child-borderradiusrighttop-input" type="number" v-model="slide.borderTopRightRadius" min="0" />
                                                </b-input-group>

                                            </b-form-group>
                                        </div>  

                                        <!--  general border radius top left DESKTOP -->
                                        <div class="setting" v-if="slide.useIndividualBorderRadius">
                                            <b-form-group>

                                                <label for="child-borderradiusbottomright-input">Bottom right:</label>
                                                
                                                <b-input-group append="px" size="sm">
                                                    <b-form-input id="child-borderradiusbottomright-input" type="number" v-model="slide.borderBottomRightRadius" min="0" />
                                                </b-input-group>

                                            </b-form-group>
                                        </div>  

                                        <!--  general border radius top left DESKTOP -->
                                        <div class="setting" v-if="slide.useIndividualBorderRadius">
                                            <b-form-group>

                                                <label for="child-borderradiusbottomleft-input">Bottom left:</label>
                                                
                                                <b-input-group append="px" size="sm">
                                                    <b-form-input id="child-borderradiusbottomleft-input" type="number" v-model="slide.borderBottomLeftRadius" min="0" />
                                                </b-input-group>

                                            </b-form-group>
                                        </div>   

                                    </div><!-- border-group -->

                                </div>
                            </div>

                            <!-- dimensions settings -->
                            <div class="setting-section">
                                <div class="setting-section-title">
                                    <h6>dimensions</h6>
                                </div>
                                <div class="setting-section-content">

                                    <!-- <div> -->
                                        <!-- child width -->
                                        <!-- <div class="setting">
                                        
                                            <b-form-group>

                                                <label for="flexchild-minheight-input">Minimum height slide:</label>
                                                
                                                <b-input-group append="px" size="sm">
                                                    <b-form-input id="flexchild-minheight-input" type="number" v-model="slide.minHeight" min="50" step="20" />
                                                </b-input-group>

                                            </b-form-group>
                                        </div> -->

                                    <!-- </div> -->

                                    <!-- horizontal padding child DESKTOP -->
                                    <div class="setting">
                                        <b-form-group>

                                            <label for="flexchild-horizontalpadding-input">Horizontal padding desktop:</label>
                                            
                                            <b-input-group append="px" size="sm">
                                                <b-form-input id="flexchild-horizontalpadding-input" type="number" v-model="slide.horizontalPad" min="0" />
                                            </b-input-group>

                                        </b-form-group>
                                    </div>      

                                    <!-- vertical padding child DESKTOP -->
                                    <div class="setting">
                                        <b-form-group>

                                            <label for="flexchild-verticalpadding-input">Vertical padding desktop:</label>
                                            
                                            <b-input-group append="px" size="sm">
                                                <b-form-input id="flexchild-verticalpadding-input" type="number" v-model="slide.verticalPad" min="0" />
                                            </b-input-group>

                                        </b-form-group>
                                    </div>

                                </div><!-- setting-section-content -->
                            </div>

                            <!-- dimensions settings -->
                            <div class="setting-section">

                                <div class="setting-section-title">
                                    <h6>animations</h6>
                                </div>


                            </div>

                        </div>

                    </div>

                </div>
            </vue-draggable-resizable>

        </transition>


        <div v-if="showBlockActionButtons && settingsFromWeebly.settings.slideReordering" :id="slideId+'-tooltip-delete'" class="delete-child-icon" @click="confirmBlockDelete = true">
            <i class="fas fa-times"></i>
        </div>

        <b-tooltip v-if="showBlockActionButtons && settingsFromWeebly.settings.slideReordering" :target="slideId+'-tooltip-delete'">
            <div class="delete-block-tooltip">Delete</div>
        </b-tooltip>

        <div class="confirm-block-deletion" v-if="confirmBlockDelete">
            <h4>Permanent Action</h4>
            <p>Are you sure you want to delete this slide?</p>
            <span @click="deleteChildBlock(slideIndex)" class="confirm-delete-block-action">
                <i class="far fa-trash-alt"></i>Yes, delete.
            </span>
            <span @click="confirmBlockDelete = false">
                <i class="fas fa-ban"></i>Cancel.
            </span>
        </div>

        <div v-if="showBlockActionButtons && settingsFromWeebly.settings.slideReordering" class="settings-child-icon" @click="showChildBlockSettings(slideId)" :id="slideId+'-tooltip-settings'">
            <i class="fas fa-cog"></i>
        </div>

        <b-tooltip v-if="showBlockActionButtons && settingsFromWeebly.settings.slideReordering" class="access-settings-tooltip" :target="slideId+'-tooltip-settings'">
            <div class="access-settings-tooltip">Settings</div>
        </b-tooltip>

        <div v-if="showBlockActionButtons && settingsFromWeebly.settings.slideReordering" class="copy-child-icon" @click="copyChild(slideIndex)" :id="slideId+'-tooltip-copy'">
            <i class="far fa-copy"></i>
        </div>

        <b-tooltip v-if="showBlockActionButtons && settingsFromWeebly.settings.slideReordering" class="access-copy-tooltip" :target="slideId+'-tooltip-copy'">
            <div class="access-copy-tooltip">Copy</div>
        </b-tooltip>

        <div class="block-drag-handle" v-if="showBlockActionButtons && settingsFromWeebly.settings.slideReordering">
            <i class="fas fa-ellipsis-h"></i>
        </div>

        <div class="loading-overlay" v-if="showBlockActionButtons && deletingChild">
            
            <div class="spinner-save">
                <b-spinner variant="primary" label="Saving" />
                <div class="spinner-save-text">
                    Deleting slide
                </div>
            </div>
                
        </div>

        <div class="bundle-content-slider--slide-inner">
            {content{{slideId}}:content}
        </div>
    </div>

</template>

<script>
import draggable from 'vuedraggable'
import Mycolorpicker from '../Mycolorpicker'
import Mycolorpickerchildblocksslide from '../Mycolorpickerchildblocksslide'

import VueDraggableResizable from 'vue-draggable-resizable'

import axios from 'axios'

export default {

    props: ['slideId', 'slideIndex','slide'],

    name: 'ContentSliderSlideCarousel',

    data() {
        return {
            
            editable_dashboard: true,

            // show child block action buttons: settings + delete
            showBlockActionButtons: false,
            showChildSettings: false,

            confirmBlockDelete: false,
            deletingChild: false,

            curSettings: '',

            setBoxWidth: 353,
            setBoxHeight: 403,

            centerPositionSettingsBoxX: null,
            centerPositionSettingsBoxY: null

        }
    },

    methods: {

        copyChild(elToCopy) {
            this.$store.state.weeblySettings.settings.slides.push(
                {
                    slideId: 'content-slide-'+Math.random().toString(36).substr(2, 16),
                    childBackground: this.$store.state.weeblySettings.settings.slides[elToCopy].childBackground,
                    horizontalPad: this.$store.state.weeblySettings.settings.slides[elToCopy].horizontalPad,
                    verticalPad: this.$store.state.weeblySettings.settings.slides[elToCopy].verticalPad,

                    borderGeneralColor: this.$store.state.weeblySettings.settings.slides[elToCopy].borderGeneralColor,
                    borderGeneralStyle: this.$store.state.weeblySettings.settings.slides[elToCopy].borderGeneralStyle,
                    borderGeneralWidth: this.$store.state.weeblySettings.settings.slides[elToCopy].borderGeneralWidth,

                    useIndividualBorder: this.$store.state.weeblySettings.settings.slides[elToCopy].useIndividualBorder,

                    borderTopColor: this.$store.state.weeblySettings.settings.slides[elToCopy].borderTopColor,
                    borderTopStyle: this.$store.state.weeblySettings.settings.slides[elToCopy].borderTopStyle,
                    borderTopWidth: this.$store.state.weeblySettings.settings.slides[elToCopy].borderTopWidth,
                    
                    borderRightColor: this.$store.state.weeblySettings.settings.slides[elToCopy].borderRightColor,
                    borderRightStyle: this.$store.state.weeblySettings.settings.slides[elToCopy].borderRightStyle,
                    borderRightWidth: this.$store.state.weeblySettings.settings.slides[elToCopy].borderRightWidth,
                    
                    borderBottomColor: this.$store.state.weeblySettings.settings.slides[elToCopy].borderBottomColor,
                    borderBottomStyle: this.$store.state.weeblySettings.settings.slides[elToCopy].borderBottomStyle,
                    borderBottomWidth: this.$store.state.weeblySettings.settings.slides[elToCopy].borderBottomWidth,
                    
                    borderLeftColor: this.$store.state.weeblySettings.settings.slides[elToCopy].borderLeftColor,
                    borderLeftStyle: this.$store.state.weeblySettings.settings.slides[elToCopy].borderLeftStyle,
                    borderLeftWidth: this.$store.state.weeblySettings.settings.slides[elToCopy].borderLeftWidth,

                    useIndividualBorderRadius: this.$store.state.weeblySettings.settings.slides[elToCopy].useIndividualBorderRadius,

                    borderRadiusGeneral: this.$store.state.weeblySettings.settings.slides[elToCopy].borderRadiusGeneral,
                    borderTopLeftRadius: this.$store.state.weeblySettings.settings.slides[elToCopy].borderTopLeftRadius,
                    borderTopRightRadius: this.$store.state.weeblySettings.settings.slides[elToCopy].borderTopRightRadius,
                    borderBottomRightRadius: this.$store.state.weeblySettings.settings.slides[elToCopy].borderBottomRightRadius,
                    borderBottomLeftRadius: this.$store.state.weeblySettings.settings.slides[elToCopy].borderBottomLeftRadius,

                    backgroundColorChild: this.$store.state.weeblySettings.settings.slides[elToCopy].backgroundColorChild,
                    backgroundImageChild: this.$store.state.weeblySettings.settings.slides[elToCopy].backgroundImageChild,
                    backgroundImageChildSet: this.$store.state.weeblySettings.settings.slides[elToCopy].backgroundImageChildSet,

                    xAxisPosition: this.$store.state.weeblySettings.settings.slides[elToCopy].xAxisPosition,
                    yAxisPosition: this.$store.state.weeblySettings.settings.slides[elToCopy].yAxisPosition,
                    slideAnimation: this.$store.state.weeblySettings.settings.slides[elToCopy].slideAnimation,
                    animationClass: this.$store.state.weeblySettings.settings.slides[elToCopy].animationClass
                }
            )
        },

        showChildBlockSettings(titleId) {
            console.log(titleId)
            document.querySelector('.bundle-slider').style.overflow = 'visible'
        },

        deleteChildBlock(slideIndex) {

            this.confirmBlockDelete = false
            this.deletingChild = true
            console.log('delete index: ',slideIndex)
            console.log('before ',this.$store.state.weeblySettings.settings.slides)
            this.$store.state.weeblySettings.settings.slides.splice(this.slideIndex, 1)

            this.reloadFlickity()

            console.log('after ',this.$store.state.weeblySettings.settings.slides)

        },

        reloadFlickity() {

            console.log('we removed');
            // create it to destroy it
            // var flkty = new Flickity( '.bundle-content-slider');
            // // destroy it
            // flkty.destroy();

            setTimeout( ()=> {
                // this.flickityStart()
                this.deletingChild = false
            },1000);

        },

        flickityStart: function() {
            // settings
            var wrapAround = this.$store.state.weeblySettings.settings.loop == 'true' || this.$store.state.weeblySettings.settings.loop == true ? true : false

            var flkty = new Flickity( '.bundle-content-slider', {
                wrapAround: wrapAround
            });
        },

        showChildBlockSettings(slideId) {


            let curEvent = event.target
            setTimeout( () => {
                this.curSettings = document.getElementById('child-block-settings-'+slideId)
                this.curIcon = curEvent
            },500)
            

            let guide = document.getElementById('child-block-settings-'+slideId+'-guide')

            console.log('offset left guide ',guide.offsetLeft)
            console.log('offset top guide ',guide.offsetTop)

            this.centerPositionSettingsBoxX = guide.offsetLeft
            this.centerPositionSettingsBoxY = guide.offsetTop

            console.log(slideId)

            // show child settings
            this.showChildSettings = true
            // add event listener
            setTimeout( ()=> {
                document.addEventListener('click', this.addClickSettingsBox)
            },1000)
            
        },
       
        addClickSettingsBox() {
            
            const el = this.curSettings
            const icon = this.curIcon
            let target = event.target

			if((el !== target && !el.contains(target)) && icon !== target) {

                setTimeout( () => {
                    document.removeEventListener('click', this.addClickSettingsBox)
                    // hide child settings
                    this.showChildSettings = false
                },150)
               
            } else {
                console.log(' target so leave settings')
            }

        },

        onFileSelected(index) {

            this.selectedFile = event.target.files[0]

            let fd = new FormData();
            fd.append('image', this.selectedFile)
            axios.post('/weebly/app_in_process/buttons/imageUpload.php', fd, {
                // headers: {
                //     'Content-Type': 'multipart/form-data'
                // }
            })
            .then(res => {
                console.log(res)
                // this.imageBg = 'https://appjustable.com/weebly/app_in_process/buttons/'+res.data

                this.$store.state.weeblySettings.settings.slides[index].backgroundImageChildSet = 'https://appjustable.com/weebly/app_in_process/buttons/'+res.data

            }).catch( error => {
                console.log(error);
            })

            // check if parallax was activated and if so, do run it on this element
            if(this.$store.state.weeblySettings.settings.slides[index].useParallax === true){
                this.activateParallax()
            }

        },

        useBackgroundColor(index) {
            if(event.target.checked === true) {
                this.activateParallax()
                this.$store.state.weeblySettings.settings.slides[index].backgroundColorChild = true
                this.$store.state.weeblySettings.settings.slides[index].backgroundImageChild = false
            } else {
                this.$store.state.weeblySettings.settings.slides[index].backgroundColorChild = false
                this.$store.state.weeblySettings.settings.slides[index].backgroundImageChild = true
            }
            
        },

        useBackgroundImage(index) {
            if(event.target.checked === true) {
                this.$store.state.weeblySettings.settings.slides[index].backgroundColorChild = false
                this.$store.state.weeblySettings.settings.slides[index].backgroundImageChild = true
            } else {
                this.$store.state.weeblySettings.settings.slides[index].backgroundColorChild = true
                this.$store.state.weeblySettings.settings.slides[index].backgroundImageChild = false

            }
        },

    },

    components: {
        draggable,

        'vue-draggable-resizable': VueDraggableResizable,

        // color picker
        Mycolorpicker,
        Mycolorpickerchildblocksslide

    },

    computed: {
        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        // get array of titles
        // slidesArray() {
        //     return this.$store.state.weeblySettings.settings.slides
        // },

        globalSettings() {
            return this.$store.state
        },

        // block guide
        showBlockChildSettingsGuide() {
            return this.$store.state.showBlockChildSettingsGuide
        }

    },

    mounted() {

        // this.flickityStart()

    }

}
</script>

<style lang="less">
@import '../../../../less/colors.less';

.settings-box-child {
    position: absolute;
    // top: calc(~"100% + 15px");
    // left: 50%;
    // transform: translateX(-50%);
    width: 350px;
    background: #fff;
    border: 1px solid @border_grey_dark;
    z-index: 100;
    border-radius: .25rem;
    margin-bottom: 30px;
    box-shadow: 0 3px 17px fade(@title_grey, 20%);

    &:after, &:before {
        bottom: 100%;
        left: 50%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }

    &:after {
        border-color: rgba(242, 243, 245, 0);
        border-bottom-color: #fff;
        border-width: 8px;
        margin-left: -8px;
    }
    &:before {
        border-color: rgba(187, 199, 213, 0);
        border-bottom-color: #bbc7d5;
        border-width: 9px;
        margin-left: -9px;
    }

    .settings-box-child-inner {
        overflow-y: auto;
        height: 350px;
        padding: 15px;
        font-size: 12px;
        width: 350px;
        background: @light_blue;

        label {
            font-weight: 700;
            color: @title_grey;
        }

        .color-picker-group .color-picker-tool {
            max-width: 220px;
            left: 50%;
            transform: translateX(-50%)

        }
    }

    .settings-box-child-title {
        h6 {
            border-bottom: 1px solid @border_grey_medium;
            padding: 0 15px;
            line-height: 50px;
            margin:0;
            background: #fff;
            border-radius: 0.25rem 0.25rem 0 0;
            font-size: 15px;
            font-weight: 700;
            text-align: center;
            text-transform: capitalize;
            cursor: move;
            cursor: grab;

            &:focus, &:active {
                cursor: move;
                cursor: grabbing;
            }
        }
    }

    .setting {
        margin-bottom: 30px;
        background: #fff;
        padding: 7px 0;
        border: 1px solid @border_grey_medium;
    }
}

.setting-section .setting-section-content {
    padding: 15px 7px 0;
    background: #fff;
    border: 1px solid @border_grey_medium;
}

.border-group .setting {
    padding: 0;
    border: 0;
    background: none;
    margin-bottom: 0;
}

.setting-section .setting-section-content .setting {
    border: 0;
    margin-bottom: 15px;
}

.settings-box-child-guide {
    position: absolute;
    // top: calc(~"100% + 15px");
    top: 30px;
    left: 50%;
    margin-left: -175px;
    width: 350px;   
    height: 0px;
    opacity: 0;
    z-index: -2;
    overflow: hidden;
}

.bundle-content-slider--slide {
    position: relative;
}
.access-settings-tooltip, .delete-block-tooltip, .access-copy-tooltip {
    background: @action_blue;
    padding: 7px;
    font-weight: 700;
}

.delete-block-tooltip {
    background: @warning_red;
}
.access-copy-tooltip {
    background: @spark_green;
}
.content-slider {
  .confirm-block-deletion {
    position: absolute;
    top: 7px;
    right: 50%;
    margin-right: -175px;
    width: 350px;
    background: #fff;
    border: 1px solid @shark_light;
    z-index: 1000;
    font-size: 12px;
    border-radius: .25rem;
    text-align: center;
    box-shadow: 0 4px 10px fade(@shark_light, 25%);

    h4 {
        font-size: 20px;
        font-weight: 400;
        background: @shark_light;
        color: #fff;
        padding: 10px;
    }

    p {
        font-size: 13px;
        padding: 15px;
        margin: 0;
    }

    span {
        margin: 5px 5px 15px;
        display: inline-block;
        font-weight: 700;
        cursor: pointer;
        color: @text_grey;
        font-size: 13px;
        padding: 7px 12px;
        background: fade(@shark_light,12%);
        border-radius: .25rem;

        &:hover {
            opacity: .9;
        }

        i {
            margin-right: 7px;
        }
    }

    .confirm-delete-block-action {
        background: @warning_red;
        color: #fff;
    }
}

.block-drag-handle {
    position: absolute;
    top: 7px;
    left: 50%;
    height: 20px;
    width: 34px;
    margin-left: -17px;
    background: #fff;
    cursor: move;
    z-index: 10;
    border-radius: .25rem;
    text-align: center;
    border: 1px solid @action_blue;

    i {
        font-size: 10px;
        line-height: 20px;
        color: @action_blue;
    }
}

.copy-child-icon {
    position: absolute;
    top: 7px;
    left: 30px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background: @spark_green;
    border-radius: .25rem;
    cursor: pointer;
    z-index: 10;
    
    i {
        color: #fff;
        font-size: 10px;
        line-height: 20px;
        
    }

    &:hover {
        background: fade(@spark_green, 85%);
    }
}

.settings-child-icon {
    position: absolute;
    top: 7px;
    left: 7px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background: @action_blue;
    border-radius: .25rem;
    cursor: pointer;
    z-index: 10;
    
    i {
        color: #fff;
        font-size: 10px;
        line-height: 20px;
        
    }

    &:hover {
        background: fade(@action_blue, 85%);
    }
}

.delete-child-icon {
    z-index: 10;
    position: absolute;
    top: 7px;
    right: 7px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background: @warning_red;
    border-radius: .25rem;
    cursor: pointer;

    i {
        color: #fff;
        font-size: 12px;
        line-height: 20px;
    }

    &:hover {
        background: fade(@warning_red, 85%);
    }
}  
}


.sortable-chosen {
    opacity: .7;
    border: 1px solid @action_blue;
}
.ghost-block {
    background: @action_blue!important;
    opacity: .2;
}

input.div-like-input {
    padding: 0;
    margin: 0;
    line-height: 1;
    width: 100%;
    outline: none!important;
    background: none;
    border: 0;
}

.dummy-title {
    font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/components/elements/elementSettings/contentsliderslide/ContentSliderSlideCarousel.vue